import { css } from '@emotion/react';

export const rootStyles = css`
  display: inline-flex;
  align-items: center;
  gap: 7px;
`;

export const dotStyles = css`
  width: var(--ti-dot-size, 4px);
  height: var(--ti-dot-size, 4px);
  border-radius: 999px;
  background-color: var(--ti-inactive-color, var(--color-neutral-300));
  transform-origin: center bottom;
  transform: scale(1) translateY(0);
  animation: lt-thinking-indicator-dot 1.3s ease-in-out infinite;

  @keyframes lt-thinking-indicator-dot {
    0%,
    15%,
    65%,
    100% {
      transform: scale(1) translateY(0);
      background-color: var(--ti-inactive-color, var(--color-neutral-300));
    }

    35% {
      transform: scale(var(--ti-peak-scale, 2.1)) translateY(-1px);
      background-color: var(--ti-active-color, var(--color-neutral-700));
    }
  }
`;
